// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export const environment = {
    production: true,
    baseUrl: '', // Change this to the address of your backend API if different from frontend address
    tokenUrl: null, // For IdentityServer/Authorization Server API. You can set to null if same as baseUrl
    loginUrl: '/login',
    isMaintenanceModeActive: false
};
